import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar"; // Desktop navbar
import MobileBottomNav from "../components/MobileBottomNav"; // Mobile navigation
import StyledGlobalPlayer from "../components/StyledGlobalPlayer"; // Desktop player
import MobilePlayer from "../components/MobilePlayer"; // Mobile player
import AppBanner from "../components/AppBanner"; // Smart app banner
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../context/AuthProvider";

const MemoizedGlobalPlayer = React.memo(StyledGlobalPlayer);

const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { user } = useAuth();

  return (
    <div className="app-container">
      {/* App Banner - Shows when user comes from mobile app sharing */}
      <AppBanner 
        // Custom colours to match Lsnto theme
        gradientColors={['#FF4081', '#9C27B0']} // Pink to purple (default)
        // gradientColors={['#FF0054', '#FFD700']} // Pink to yellow
        // gradientColors={['#290057', '#DC3AFC']} // Purple to pink
        textColor="white"
        buttonBackgroundColor="rgba(255,255,255,0.2)"
        buttonHoverColor="rgba(255,255,255,0.3)"
      />
      
      {isMobile ? (
        <>
          <div className="content" style={{ paddingBottom: "56px" }}>
            <Outlet />
          </div>

          {/* Mobile Player pinned above bottom navigation - Only for logged-in users */}
          {user && (
            <div
              className="fixed-player-container"
              style={{ position: "fixed", bottom: "56px", left: 0, width: "100%" }}
            >
              <MobilePlayer />
            </div>
          )}

          {/* Mobile bottom navigation */}
          <div
            className="fixed-bottom-nav-container"
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              zIndex: 1100,
            }}
          >
            <MobileBottomNav />
          </div>
        </>
      ) : (
        <>
          <div className="fixed-navbar-container">
            <Navbar />
          </div>
          <div className="content">
            <Outlet />
          </div>
          {/* Desktop Global Player - Only for logged-in users */}
          {user && (
            <div className="fixed-player-container">
              <MemoizedGlobalPlayer />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MainLayout;







